import { AHRIDataModel, AHRISystemToolAttributeModel, AHRISystemToolCategoryModel, AHRISystemToolModel } from "@crescentParts/Widgets/CustomApiModels";
import { ApiParameter, get, post } from "@insite/client-framework/Services/ApiService";

export interface BrandParameter extends ApiParameter {
    brand: string;
}
export interface AHRIDataParameter extends ApiParameter {
    Family: string;
    AC_HeatPump: string;
    Outdoor_Unit_Tonnage: string;
    Family_SEER2: string;
    Indoor_Type: string;
    Furnace_BTU: string;
    Indoor_Position: string;
    C25_Tax_Credit_Qualified: string;
    page: number;
    Sort: string;
    search: string;
    refrigerant: string;
}
const AHRISystemToolBrandUrl = "/api/v2/AHRISystem";
const AHRISystemToolAttributeUrl = "/api/v2/AHRISystem/GetAHRIFilters";
const AHRISystemToolDataUrl = "/api/v2/AHRISystem/GetAHRIFilteredData";

export function getAHRISystemToolBrand() {
    return get<AHRISystemToolModel>(`${AHRISystemToolBrandUrl}`);
}

export function getAHRISystemToolCategory(parameter: BrandParameter) {
    return get<AHRISystemToolCategoryModel>(`${AHRISystemToolBrandUrl}/${parameter.brand}`);
}
export function getAHRISystemToolAttribute() {
    return get<AHRISystemToolAttributeModel>(`${AHRISystemToolAttributeUrl}`);
}

export function getAHRISystemToolData(parameter: AHRIDataParameter) {
    return post<AHRIDataModel>(`${AHRISystemToolDataUrl}`, parameter);
}